import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07c59868"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qualitychecksafe-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("未知")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("男")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("女")
const _hoisted_5 = { class: "fujian" }
const _hoisted_6 = { class: "button" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("提交")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.title,
      placeholder: "",
      onClickLeft: _ctx.goBack
    }, null, 8, ["title", "onClickLeft"]),
    _createVNode(_component_van_form, { onSubmit: _ctx.onSubmit }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.submitform.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.submitform.name) = $event)),
            rules: [{ required: true, message: '请输入您的姓名' }],
            required: "",
            label: "姓名",
            placeholder: "请输入您的姓名",
            maxlength: "50"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_field, {
            modelValue: _ctx.submitform.phone,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.submitform.phone) = $event)),
            rules: [{ required: true, message: '请输入您的手机号' }],
            required: "",
            label: "手机号",
            placeholder: "请输入您的手机号",
            maxlength: "50"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_field, {
            name: "radio",
            label: "性别"
          }, {
            input: _withCtx(() => [
              _createVNode(_component_van_radio_group, {
                modelValue: _ctx.submitform.sex,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.submitform.sex) = $event)),
                direction: "horizontal"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_radio, { name: "1" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_radio, { name: "2" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_radio, { name: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_field, {
            modelValue: _ctx.submitform.age,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.submitform.age) = $event)),
            label: "年龄",
            placeholder: "请输入您的年龄",
            maxlength: "50"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.submitform.startPlan,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.submitform.startPlan) = $event)),
            rules: [{ required: true, message: '请选择预计来访时间' }],
            "is-link": "",
            required: "",
            readonly: "",
            clickable: "",
            label: "来访时间",
            placeholder: "请选择预计来访时间",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resultStartPlanPicker = true))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_popup, {
            show: _ctx.resultStartPlanPicker,
            "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.resultStartPlanPicker) = $event)),
            position: "bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_datetime_picker, {
                modelValue: _ctx.currentDate,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentDate) = $event)),
                type: "datetime",
                "min-date": _ctx.minDate,
                "max-date": _ctx.maxDate,
                onCancel: _cache[7] || (_cache[7] = ($event: any) => (_ctx.resultStartPlanPicker = false)),
                onConfirm: _ctx.confirmStartPlanPicker
              }, null, 8, ["modelValue", "min-date", "max-date", "onConfirm"])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_component_van_field, {
            modelValue: _ctx.submitform.endPlan,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.submitform.endPlan) = $event)),
            rules: [{ required: true, message: '请选择预计结束时间' }],
            "is-link": "",
            required: "",
            readonly: "",
            clickable: "",
            label: "结束时间",
            placeholder: "请选择预计结束时间",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.resultEndPlanPicker = true))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_popup, {
            show: _ctx.resultEndPlanPicker,
            "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.resultEndPlanPicker) = $event)),
            position: "bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_datetime_picker, {
                modelValue: _ctx.currentDate,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.currentDate) = $event)),
                type: "datetime",
                "min-date": _ctx.minDate,
                "max-date": _ctx.maxDate,
                onCancel: _cache[12] || (_cache[12] = ($event: any) => (_ctx.resultEndPlanPicker = false)),
                onConfirm: _ctx.confirmEndPlanPicker
              }, null, 8, ["modelValue", "min-date", "max-date", "onConfirm"])
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.submitform.reason,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.submitform.reason) = $event)),
            rows: "2",
            autosize: "",
            rules: [{ required: true, message: '请输入来访原因' }],
            label: "来访原因",
            type: "textarea",
            maxlength: "200",
            placeholder: "请输入来访原因",
            "show-word-limit": "",
            required: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_field, {
            modelValue: _ctx.submitform.visitUserName,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.submitform.visitUserName) = $event)),
            rules: [{ required: true, message: '请输入或选择来访人' }],
            required: "",
            label: "受访人",
            placeholder: "请输入或选择来访人",
            maxlength: "50",
            onBlur: _cache[16] || (_cache[16] = ($event: any) => (_ctx.selectInterviewee()))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_popup, {
            show: _ctx.visitUserSelect,
            "onUpdate:show": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.visitUserSelect) = $event)),
            position: "bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_picker, {
                title: "人员选择",
                columns: _ctx.IntervieweeList,
                "columns-field-names": _ctx.IntervieweeListField,
                onConfirm: _ctx.confirmInterviewee,
                onCancel: _cache[17] || (_cache[17] = ($event: any) => (_ctx.visitUserSelect = false))
              }, null, 8, ["columns", "columns-field-names", "onConfirm"])
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_van_field, {
            rules: [
            {
              required: true,
              message: '(请将手机横置拍照,确保图片人脸角度正确)',
            },
          ],
            label: "上传人脸"
          }, {
            input: _withCtx(() => [
              _createVNode(_component_van_uploader, {
                modelValue: _ctx.uploader,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.uploader) = $event)),
                "after-read": _ctx.afterRead,
                multiple: _ctx.$isIOS()
              }, null, 8, ["modelValue", "after-read", "multiple"])
            ]),
            _: 1
          }, 8, ["rules"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_van_button, {
            block: "",
            disabled: _ctx.flag,
            type: "primary",
            "native-type": "onSubmit"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}